module.exports = __webpack_public_path__ + "static/img/__9360.813e722.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9360.jpg
// module id = RKfC
// module chunks = 0